<template>
    <div>
        
    <div id="myQR" ref="myQR">
        <div ref="containerShowCanvas"></div>
    <table style="padding: 10px;border: solid 2px black;background-color: white;" >
        <tbody>
            <tr>
                <td>
                <qrcode-svg :value="urlAction" level="H" render-as="canvas" margin="1" size="200"/>
                </td>
            </tr>
            <tr>
                <td>
                    <center style="font-size: 40px;font-weight: bolder;">LV 01</center>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div>
    <br>
    <button @click="downloadImage">previewImage</button>
    <a @click="convertImage" href="#">
    Download
  </a>
</div>
<div>
    <h3>Preview</h3>
</div>
</div>

</template>
<script>
import { ref } from "vue";
import QrcodeVue, { QrcodeCanvas, QrcodeSvg } from 'qrcode.vue'
import html2canvas from 'html2canvas';
const qrRef = ref(null);
const containerShowCanvas = ref(null);

export default {
    components:{
        QrcodeSvg,
        QrcodeCanvas,
        QrcodeVue,
    },
    mounted() {
    },
    data() {
        return {
            urlAction: "/",
            getCanvas:null,
        };
    },
    props: ["tokens", "url_action"],
    methods: {
        async downloadImage(){
            const canvas = await html2canvas(this.$refs.qrRef);
            console.log("CANVAS :"+canvas)
            // containerShowCanvas.value.appendChild(canvas)
        },
    }
}
</script>